<script>
export default {
  name: 'form-validator',
  data() {
    return {
      formValidationMessages: {
        // This value is required.
        required: 'Este campo es obligatorio.',
        // This value is not formatted correctly.
        format: 'Este valor no tiene el formato correcto.',
        // The passwords do not match.
        passwordMatch: 'Las contraseñas no coinciden.',
        // The password does not meet security criteria.
        passwordCriteria: 'La contraseña no cumple con los criterios de seguridad.',
      },
    };
  },
  methods: {
    validate(fields = []) {
      const { validations } = this;
      let passed = true;
      fields.forEach((field) => {
        const input = validations[field].value;
        const trimmed = input.replace(/^\s*$/, '');
        validations[field].errors = [];
        // required checks
        if (validations[field].required && trimmed === '') {
          validations[field].errors.push(this.formValidationMessages.required);
          if (passed) {
            passed = false;
          }
        }
        // format checks
        if (validations[field].format && trimmed !== '') {
          const notFormated = !input.match(validations[field].format);
          if (notFormated) {
            validations[field].errors.push(this.formValidationMessages.format);
            if (passed) {
              passed = false;
            }
          }
        }
      });
      return { passed };
    },
  },
};
</script>
